export const ADD_LANGUAGE = 'tolgee/ADD_MD';
export const ADD_MARKETPLACE = 'tolgee/ADD_MARKETPLACE';
export const ADD_TOLGEE_STATIC_DATA = 'tolgee/ADD_TOLGEE_STATIC_DATA';
